import { useMemo } from 'react';

import { useAppSelector } from '@/Module/Store/Hook';
import type { ISubscriptionPlan } from '@/Module/Subscription/Model/DataModel';
import { selectedSubscriptionPlanActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionPlanActiveSelector';

export const useSubscriptionPlans = () => {
  const planList = useAppSelector(selectedSubscriptionPlanActiveSelector);

  const { lightPlans, proPlans } = useMemo(() => {
    const filteredLightPlans: ISubscriptionPlan[] = [];
    const filteredProPlans: ISubscriptionPlan[] = [];

    for (const plan of planList) {
      if (plan.sortOrder === 150) {
        filteredLightPlans.push(plan);
      } else if (plan.sortOrder === 200) {
        filteredProPlans.push(plan);
      }
    }

    return { lightPlans: filteredLightPlans, proPlans: filteredProPlans };
  }, [planList]);

  return { lightPlans, proPlans };
};
